import styled from 'styled-components';
import { flexbox, flexDirection, justifyContent } from '../../styles/helpers/flexbox';

const FilterListWrapper = styled.div`
    ${flexbox()}
`;

const FilterList = styled.div`
    font-size: 14px;
    margin: 0 20px;

    .type {
      ${flexDirection('row')}
      ${justifyContent('space-between')};

      width: 150px;
    }
`;

export { FilterListWrapper, FilterList };
